(function(){
  'use strict';

  function initFade(){
    if(!('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('pav-fade-up'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.pav-trust').forEach(function(el){ obs.observe(el); });
  }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', initFade); }
  else { initFade(); }
})();

(function(){
  'use strict';
  var HIDE_MATCHES = ['Ανάρπαστο! Το καλάθι σας είναι κρατημένο','Μεγάλη ζήτηση: Κρατήσαμε τα γάντια','Μεγάλη ζήτηση: Μόνο'];
  function shouldHide(text){
    for(var i=0;i<HIDE_MATCHES.length;i++){
      if(text.indexOf(HIDE_MATCHES[i]) !== -1) return true;
    }
    return false;
  }
  function scan(root){
    if(!root || !root.querySelectorAll) return;
    var all = root.querySelectorAll('div,p,span,strong,small');
    for(var i=0;i<all.length;i++){
      var el = all[i];
      if(el.getAttribute('data-pav-hidden')) continue;
      var txt = (el.textContent || '').trim();
      if(txt.length > 0 && txt.length < 250 && shouldHide(txt)){
        el.style.setProperty('display','none','important');
        el.setAttribute('data-pav-hidden','1');
      }
    }
  }
  function start(){
    scan(document.body);
    var mo = new MutationObserver(function(){ scan(document.body); });
    mo.observe(document.body, { childList:true, subtree:true });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', start); }
  else { start(); }
})();

(function(){
  'use strict';
  function ensureStyle(){
    if(document.getElementById('pav-stock-alert-style')) return;
    var style = document.createElement('style');
    style.id = 'pav-stock-alert-style';
    style.textContent = '.stock-dot{display:inline-block;width:8px;height:8px;border-radius:50%;background-color:#e63946;animation:pulse-dot 1.5s ease-in-out infinite;flex-shrink:0;}@keyframes pulse-dot{0%{transform:scale(1);opacity:1;}50%{transform:scale(1.4);opacity:0.6;}100%{transform:scale(1);opacity:1;}}';
    document.head.appendChild(style);
  }
  function injectStockAlert(){
    var candidates = document.querySelectorAll('p.product__text--text');
    for(var i=0;i<candidates.length;i++){
      var el = candidates[i];
      if(el.children.length > 0) continue;
      var txt = (el.textContent || '').trim();
      if(txt.length < 200 && txt.indexOf('ActiveBall Pro') !== -1 && txt.indexOf('Αποκλειστική') !== -1){
        var prev = el.previousElementSibling;
        if(prev && prev.classList && prev.classList.contains('stock-alert')) continue;
        var wrapper = document.createElement('div');
        wrapper.className = 'stock-alert';
        wrapper.setAttribute('style', 'display: flex; align-items: center; gap: 6px; margin-bottom: 8px;');
        wrapper.innerHTML = '<span class="stock-dot"></span><span style="color: #e63946; font-weight: bold;">Η τρέχουσα παρτίδα είναι 85% εξαντλημένη!</span>';
        el.parentNode.insertBefore(wrapper, el);
      }
    }
  }
  function start(){
    ensureStyle();
    injectStockAlert();
    var mo = new MutationObserver(function(){ injectStockAlert(); });
    mo.observe(document.body, { childList:true, subtree:true });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', start); }
  else { start(); }
})();

